import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'

const DoxExplorerFilesTableColumnHeader = (props) => {
    const mainCheckedState = props.fileIds?.size !== 0;
    const translateString = useTranslationContext();
    const indeterminateFlag = props.fileIds?.size !== props.fileList?.filter(x => x.documentStatus !== 'Deleted').length
                                    && props.fileIds?.size !== 0;
    const handleToggle = () => {
        if (!props.isStatic) {
            props.onToggle(props.columnId)
        }
    }

    const handleCheckboxChange = (event) => {
        props.selectAllFiles(event.target.checked);
    };

    return (
        <div className={classnames(
            'doxe-files-table-cell hrb-column',
            props.columnId,
            `hrb-is-${props.width}`,
            {
                'doxe-tc-selected': props.isSelected,
                'doxe-tc-static': props.isStatic
            })}
            style={{ justifyContent: props.justifyContent }}
            onClick={handleToggle}>
            {props.columnId === 'count' && props.bulkDownloadEligibility &&
                <input className={indeterminateFlag ? ' indeterminateFlag' : 'fileSelectorCheckbox'} type='checkbox' id={props.fileCounter}
                    onChange={handleCheckboxChange} checked={indeterminateFlag || mainCheckedState} />
            }
            {props.columnId === 'count' && !props.bulkDownloadEligibility &&
                <div className={classnames('trash-can', { 'error': props.errorKey })}></div>
            }
            <span>{translateString(props.labelKey)}</span>
            {props.isSelected && !props.isReversed &&
                <FontAwesomeIcon icon={faChevronUp} />
            }
            {props.isSelected && props.isReversed &&
                <FontAwesomeIcon icon={faChevronDown} />
            }
        </div>
    )
}

DoxExplorerFilesTableColumnHeader.propTypes = {
    columnId: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    onToggle: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isReversed: PropTypes.bool.isRequired,
    isStatic: PropTypes.bool.isRequired,
    justifyContent: PropTypes.string
}

export default DoxExplorerFilesTableColumnHeader;